import { render, staticRenderFns } from "./LegalInfo.vue?vue&type=template&id=1af8ce38&scoped=true"
import script from "./LegalInfo.vue?vue&type=script&lang=js"
export * from "./LegalInfo.vue?vue&type=script&lang=js"
import style0 from "./LegalInfo.vue?vue&type=style&index=0&id=1af8ce38&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af8ce38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1af8ce38')) {
      api.createRecord('1af8ce38', component.options)
    } else {
      api.reload('1af8ce38', component.options)
    }
    module.hot.accept("./LegalInfo.vue?vue&type=template&id=1af8ce38&scoped=true", function () {
      api.rerender('1af8ce38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/SettleFlod/Child/LegalInfo.vue"
export default component.exports